'use strict';

const moment = require('moment');

var DeleteDatasetDialogController = function($scope, $rootScope) {

  var vm = this;

  vm.showDialog = false;

  $scope.$on('dialog:datasets:promptDelete', function(ev, data) {
    vm.job = data.job;
    vm.showDialog = true;
  });

  vm.closeModal = function() {
    vm.showDialog = false;
  };

  vm.formatSiteName = function () {
    if(!vm.job) {
      return '';
    }

    return vm.job.site.name;
  };

  vm.formatJobDate = function () {
    if(!vm.job) {
      return '';
    }

    return moment(vm.job.capturedAtTime).format('LL');
  };

  vm.perform = function() {
    vm.closeModal();
    $rootScope.$broadcast('dialog:datasets:confirmDelete', vm.job);
    vm.job = null;
  };

};

DeleteDatasetDialogController.$inject = ['$scope', '$rootScope'];

module.exports = DeleteDatasetDialogController;


// WEBPACK FOOTER //
// ./src/app/manager/processing/dialogs/DeleteDatasetDialogController.js